export class TodoStatuses {
  static new = Boo.Objects.Todo.Enums.TodoStatus.New;
  static complete = Boo.Objects.Todo.Enums.TodoStatus.Complete;
  static incomplete = Boo.Objects.Todo.Enums.TodoStatus.Incomplete;
}
